enum EMonths {
  JAN = 'Jan',
  FEB = 'Feb',
  MAR = 'Mar',
  APR = 'Apr',
  MAY = 'May',
  JUN = 'Jun',
  JUL = 'Jul',
  AUG = 'Aug',
  SEP = 'Sep',
  OCT = 'Oct',
  NOV = 'Nov',
  DEC = 'Dec',
}

export const MONTHS = {
  '01': EMonths.JAN,
  '02': EMonths.FEB,
  '03': EMonths.MAR,
  '04': EMonths.APR,
  '05': EMonths.MAY,
  '06': EMonths.JUN,
  '07': EMonths.JUL,
  '08': EMonths.AUG,
  '09': EMonths.SEP,
  '10': EMonths.OCT,
  '11': EMonths.NOV,
  '12': EMonths.DEC,
}

export const MONTHS_ARRAY = Array.from(Object.values(EMonths))
